import type { ComponentStyleConfig } from "@chakra-ui/theme";

export const Text: ComponentStyleConfig = {
    defaultProps: {
        color: "bodyFont",
    },
};
